<template>
  <el-aside width="220px" class="leftMenu">
    <div class="logo">
      深圳福田<br>行政执法随身包
    </div>
    <el-menu ref="sideMenu" :default-active="activeMenu" router :collapse="isCollapse">
      <template v-for="route in menuList">
        <!-- 有子路由的菜单项 -->
        <el-submenu 
          v-if="route.children && route.children.length > 0 && !route.meta?.hiddenSubMenu"
          :key="route.path"
          :index="route.path"
        >
          <template slot="title">
            <span class="iconImg" :style="getIconStyle(route.meta.icon)"></span>
            <span slot="title">{{ route.meta.title }}</span>
          </template>
          
          <el-menu-item 
            v-for="child in route.children.filter(r => !r.meta?.hidden)"
            :key="child.path"
            :index="route.path + '/' + child.path"
          >
             <span class="iconImg" :style="getIconStyle(route.meta.icon)"></span>
            <span slot="title">{{ route.meta.title }}</span>
          </el-menu-item>
        </el-submenu>
        
        <!-- 单层菜单项 -->
        <el-menu-item 
          v-else-if="!route.meta?.hidden" :key="route.path" :index="route.path">
           <span class="iconImg" :style="getIconStyle(route.meta.icon)"></span>
          <span slot="title">{{ route.meta.title }}</span>
        </el-menu-item>
      </template>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  name: 'SideMenu',   // 递归组件需要 name
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {

    }
  },
  computed: {
    // 关键：匹配父路由保持高亮
    activeMenu() {
      const route = this.$route
      const { meta, path, matched } = route
      
      // 1. 优先使用 meta 中指定的 activeMenu
      if (meta?.activeMenu) {
        return meta.activeMenu
      }

      // 如果当前是根路径 '/'，找重定向的目标
      if (path === '/') {
        const redirectRoute = matched[0]?.redirect
        if (redirectRoute) {
          return redirectRoute
        }
      }
      
      // 2. 匹配父路由：如果当前路径是子路由，找到对应的父菜单
      // matched[0] 是根路由 /，matched[1] 是父路由如 /RiskAtlas
      if (matched.length > 1) {
        const parentRoute = matched[1] // 获取父级路由
        // 检查该父路由是否在 menuList 中
        const exists = this.menuList.find(item => item.path === parentRoute.path)
        if (exists) {
          return parentRoute.path
        }
      }
      
      // 3. 默认返回当前路径
      return path
    }
  },
  watch: {
    // 监听路由变化，手动更新菜单高亮
    '$route': {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          if (this.$refs.sideMenu) {
            this.$refs.sideMenu.activeIndex = this.activeMenu
          }
        })
      }
    }
  },
  methods: {
    exitLogin() {
      console.log('退出登录');
      sessionStorage.clear()           // 清空所有 sessionStorage
      window.location.reload()  // 强制刷新跳转，清除所有状态
    },
    getIconStyle(iconName) {
      return {
        '--bg-normal': `url(${require('@/assets/images/icon_menu_' + iconName + '.png')})`,
        '--bg-active': `url(${require('@/assets/images/icon_menu_' + iconName + '_active.png')})`
      }
    }
  },
  created() {
  }
}
</script>
<style lang="less" scoped>
  .leftMenu {
    width: 220px;
    height: 100vh;
    background: linear-gradient(180deg, #4874CB, #0059D1);
    position: relative;
    .logo {
      text-align: center;
      margin: 50px 0;
      font-size: 18px;
      color: #FFFFFF;
      white-space: pre-line;
      img {
        width: 134px;
        &.line {
          width: 199px;
          height: 1px;
        }
      }
      .t {
        font-size: 12px;
        color: #B9C3C2;
        width: 134px;
        height: 20px;
        background-color: #2A3760;
        line-height: 20px;
        text-align: center;
        border-radius: 10px;
        margin: 0 auto;
      }
    }
    .el-menu {
      background-color: transparent;
      border-right: 0;
      width: 100%;
      position: absolute;
      // left: 0;
      // top: 96px;
      z-index: 3;
      .el-menu-item {
        height: 70px;
        color: #333;
        font-size: 16px;
        color: #fff;
        line-height: 70px;
        text-align: left;
        box-sizing: border-box;
        padding-left: 50px !important;
        .iconImg {
          width: 23px;
          height: 21px;
          display: inline-block;
          background-image: var(--bg-normal);
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: 18px;
        }
        &:hover, &.is-active {
          background: #FFFFFF;
          color: #0059D1;
          font-size: 16px;
          .iconImg {
            background-image: var(--bg-active);
          }
        }
      }
      
    }
  }
</style>